const getActionInitiatedData = ({
  inventory,
  label,
  isTenancy,
}: {
  inventory: any;
  label: string;
  isTenancy: boolean;
}) => ({
  id: inventory.id || inventory?.config?.id,
  config_id: inventory?.config?.id ?? (isTenancy ? inventory.parent_id : inventory.id),
  meta: inventory?.meta || inventory?.config?.meta,
  pricing: inventory?.pricing || inventory?.config?.pricing,
  config_name: inventory?.config?.name || inventory?.name?.split("_")[0],
  label,
  level: isTenancy ? "tenancy" : "config",
});

export default getActionInitiatedData;
